import { Controller } from "@hotwired/stimulus"
import { closeDropdownMenu } from "../lib/dropdown_state.mjs"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.trigger = this.element.querySelector('[data-action~="click->dropdown#toggle"]')
    this.trigger?.setAttribute("aria-expanded", String(!this.menuTarget.classList.contains("hidden")))
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    // Close any other open dropdowns first
    document.querySelectorAll('[data-controller="dropdown"] [data-dropdown-target="menu"]').forEach((menu) => {
      if (menu !== this.menuTarget) {
        closeDropdownMenu(menu)
      }
    })

    this.menuTarget.classList.remove("hidden")
    this.trigger?.setAttribute("aria-expanded", "true")
    // Defer listener to next frame so the current click doesn't immediately trigger it
    requestAnimationFrame(() => {
      document.addEventListener("click", this.closeOnClickOutside)
    })
  }

  close() {
    closeDropdownMenu(this.menuTarget)
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }
}
